
<template>
  <div :style="styles.base">
    <div class="ticket" v-if="isShowOriginLotteryNum" :style="countFontStyle">抽奖次数：{{remainRight}}</div>
    <!--    width: 7.10rem; height: 7.10rem-->
    <div id="lottery" style="position: relative; margin: auto; ">
      <img style="width: 100%" :src="configurationData.backgroundImg" alt />
    </div>
    <c-base-dialog v-model="isShow" :option="option" @confirm="isShow = false" @close="isShow = false" v-transfer-dom>
      <template slot="body">
        <div :class="getCss('reward')">
          <div v-show="showRewardPromptText">恭喜你获得了</div>
          <div v-for="(item,index) in packageNames" :key="index">{{ item }}</div>
        </div>
      </template>
    </c-base-dialog>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin, common } from '@tencent/ceiba-base-components';
import CDialog from '@tencent/ceiba-base-components/src/components/base-dialog';

export default {
  name: 'CLotterySquare',
  components: {
    [CDialog.name]: CDialog,
  },
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'lottery-square-',

      alertMsg: '',

      initLotteryConfig: {
        total: 8,
        width: 710,
        height: 710,
        sbtnx: 280,
        sbtny: 280,
        sbtnw: 215,
        sbtnh: 215,
        boxw: 215,
        boxh: 215,
        position: '3_3_0,230_3_0,455_2_0,455_230_2,455_455_2,230_455_0,3_455_0,3_230_0',
      },
      isShow: false,
      showRewardPromptText: true,
      packageName: '',
    };
  },
  computed: {
    packageNames() {
      return this.packageName ? this.packageName.split(',') : [];
    },
    option() {
      return Object.assign({}, this.dialogConfig, {
        fotter: true,
        close: true,
        header: '温馨提示',
        cancel: false,
        confirm: !!this.dialogConfig?.confirmStyle?.backgroundImage,
        confirmStyle: this.dialogConfig?.confirmStyle,
        dialogStyle: this.dialogConfig?.dialogStyle || {
          color: '#282121',
        },
      });
    },
    isShowOriginLotteryNum() {
      return this.configurationData.isShowOriginLotteryNum;
    },
    remainRight() {
      return (
        (this.quaInfo[this.configurationData.lotteryFlowID]
          && this.quaInfo[this.configurationData.lotteryFlowID].remain)
        || 0
      );
    },
    countFontStyle() {
      if (!this.styles.topFontStyle) {
        return {};
      }
      return {
        fontFamily: this.styles.topFontStyle.fontFamily,
        fontSize: this.styles.topFontStyle.fontSize,
        color: this.styles.topFontStyle.color,
        fontWeight: this.styles.topFontStyle.fontWeight,
      };
    },
    multiplier() {
      let baseWidth = 750;
      if (this.deviceMode === 'h5-h') {
        baseWidth = 1334;
      }
      return 100 * (window.screen.width / baseWidth);
    },
  },
  watch: {},
  mounted() {
    console.log('version 1.1.14 lottery square configurationData=', this.configurationData, this.uid);
    console.log(' lottery this.styles.base', this.styles.base);
    this.$nextTick(() => {
      let { width: containerWidth, height: containerheight } = this.styles.base;
      console.log('lottery  style  containerWidth containerheight', containerWidth, containerheight);
      if (containerWidth.indexOf('rem') > -1) {
        containerWidth = parseFloat(containerWidth.substring(0, containerWidth.length - 3), 3);
        containerheight = parseFloat(containerheight.substring(0, containerheight.length - 3), 3);
        containerheight = this.isShowOriginLotteryNum ? containerheight - 0.8 : containerheight;
        containerWidth = containerWidth * this.multiplier;
        containerheight = containerheight * this.multiplier;
        console.log(
          'lottery  style  containerWidth containerheight multiplier',
          containerWidth,
          containerheight,
          this.multiplier,
        );
      } else if (containerWidth.indexOf('px') > -1) {
        containerWidth = parseFloat(containerWidth.substring(0, containerWidth.length - 2), 3);
        containerheight = parseFloat(containerheight.substring(0, containerheight.length - 2), 3);
      }
      // const grayY = parseInt(containerWidth * 0.0, 10);
      // 配置过来的 背景图的横向间隙和纵向间隙 默认是 710px 下的 10px 这个是ceiba 2.0 的规范
      const { grayX = 10, grayY = 10 } = this.configurationData || {};
      const grayYComX = Math.ceil((grayX / 710) * containerWidth);
      const grayYComY = Math.ceil((grayY / 710) * containerheight);
      //  box 的宽度
      const w = Math.ceil((containerWidth - grayYComX * 2) / 3);
      //  box 的高度
      const h = Math.ceil((containerheight - grayYComY * 2) / 3);

      console.log('lottery containerWidth containerheight', containerWidth, containerheight);
      let position = `0_0_0,${w + grayYComX}_0_0,${w * 2 + grayYComX * 2}_0_0,${w * 2 + grayYComX * 2}_${
        h + grayYComY
      }_0,`;
      console.log(
        'lottery gray containerWidth =',
        containerWidth,
        ' containerheight =',
        containerheight,
        'grayX =',
        grayX,
        'grayY =',
        grayY,
        'grayYComX=',
        grayYComX,
        'grayYComY =',
        grayYComY,
        'h, w',
        h,
        w,
      );
      position += `${w * 2 + grayYComX * 2}_${h * 2 + grayYComY * 2}_0,${w + grayYComX * 2}_${
        h * 2 + grayYComY * 2
      }_0,`;
      position += `0_${h * 2 + grayYComY * 2}_0,0_${h + grayYComY * 2}_0`;

      const middleX = Math.ceil((containerWidth - w) / 2);
      const middleY = Math.ceil((containerheight - h) / 2);
      this.initLotteryConfig = {
        total: 8,
        width: containerWidth,
        height: containerheight,
        sbtnx: middleX,
        sbtny: middleY,
        sbtnw: w,
        sbtnh: h,
        boxw: w,
        boxh: h,
        position,
      };
      console.log(' make  lottery this.initLotteryConfig version 1.1.8', this.initLotteryConfig, this.uid);
      this.initialize();
    });
  },

  methods: {
    initialize() {
      common.tool.loadScript('lottery-js', '//game.gtimg.cn/images/js/delottery/lottery.js', () => {
        this.initLottery();
      });
    },
    initLottery() {
      if (this.$isInEditor) return;
      if (!window.Lottery) return;
      const self = this;
      console.log(' self.remainRight', self.remainRight, this.isShowOriginLotteryNum);
      self.lottery = new window.Lottery({
        lighturl: self.configurationData.productImg,
        starturl: self.configurationData.startImg,
        ...self.initLotteryConfig,
        contentId: 'lottery',
        async onClickRollEvent() {
          // const index1 =  self.generateLotteryIndex(2000);
          // return self.lottery.stopRoll(index1);
          console.log('clickRoll');
          self.reportClick({
            ceibaComponentId: `${self.cid}`,
            ceibaComponentUid: self.uid,
            ceibaComponentUname: self.uname,
          });
          if (!self.$ast.isAPP() && self.configurationData.forceApp) {
            return self.$ast.gotoAPP();
          }
          // 检测角色绑定
          if (self.actInfo.extendConfig.forceRole && !self.isRoleReady && self.isRoleStatusValid) {
            self.lottery.reset();
            self.alert('请先绑定角色');
            return;
          }

          if (self.isShowOriginLotteryNum && self.remainRight <= 0) {
            self.lottery.reset();
            self.alert('抽奖次数不足');
            return;
          }
          // 前置钩子：app, 登录校验，上报，参数校验等
          if (
            !(await self.doHook({
              name: 'before_lottry',
            }))
          ) {
            self.lottery.reset();
            return;
          }

          const response = await self.flowRequest({
		            flowId: self.configurationData.lotteryFlowID,
		            params: { role: self.roleInfo },
		          });

          await self.doHook({
            name: 'after_lottery',
            options: {
              meta: self.meta,
              configurationData: self.configurationData,
              response,
            },
          }); // 后置动作，上报等
          console.log('response=', response);
          // 第一层报错
          const { ret: rspRet, msg: rspMsg } = response;
          if (rspRet !== 0) {
            self.reportClickRaw({
              ceibaComponentId: `${self.cid}`,
              ceibaComponentUid: self.uid,
              ceibaComponentUname: self.uname,
              eventKey: 'lottery',
              eventData: {
                gift_id: '',
                status: '0',
              },
            });
            self.lottery.reset();
            // 弹窗提示，上报
            self.alert(rspMsg);
            self.refreshQua();
            return;
          }

          const { ret, package_id, msg } = response.data || {};
          // 第二层报错
          if (ret !== 0) {
            self.reportClickRaw({
              ceibaComponentId: `${self.cid}`,
              ceibaComponentUid: self.uid,
              ceibaComponentUname: self.uname,
              eventKey: 'lottery',
              eventData: {
                gift_id: '',
                status: '0',
              },
            });
            self.lottery.reset();
            // 弹窗提示，上报
            self.alert(msg);
            self.refreshQua();
            return;
          }
          // 什么都没有领取成功
          if (parseInt(package_id, 10) === 0) {
            self.reportClickRaw({
              ceibaComponentId: `${self.cid}`,
              ceibaComponentUid: self.uid,
              ceibaComponentUname: self.uname,
              eventKey: 'lottery',
              eventData: {
                gift_id: '',
                status: '0',
              },
            });
            self.lottery.reset();
            // 弹窗提示，上报
            self.alert(msg);
            self.refreshQua();
            return;
          }
          self.reportClickRaw({
            ceibaComponentId: `${self.cid}`,
            ceibaComponentUid: self.uid,
            ceibaComponentUname: self.uname,
            eventKey: 'lottery',
            eventData: {
              gift_id: response.data.package_id || '',
              status: '1',
            },
          });
          const index = self.generateLotteryIndex(response.data.package_id);
          if (index !== -1) {
            self.packageName = response.data.msg.replace('恭喜您获得了礼包： ', '');
            console.log('self.packageName===', self.packageName, self.packageName.length, typeof self.packageName !== 'undefined' && self.packageName.indexOf('谢谢参与') > -1);
            if (typeof self.packageName !== 'undefined' && self.packageName.indexOf('谢谢参与') > -1) {
              self.showRewardPromptText = false;
            }
            return self.lottery.stopRoll(index);
          }
          self.packageName = '领取礼包成功';
          self.lottery.reset();
          self.refreshQua();
        },
        onCompleteRollEvent() {
          self.isShow = true;
          self.refreshQua();
        },
      });
      console.log('lottery=', self.lottery);
    },
    generateLotteryIndex(packageId) {
      // eslint-disable-next-line max-len, vue/max-len
      return this.configurationData.packagePosition.findIndex(item => item.packageId
        .split(',')
        .map(num => parseInt(num, 10))
        .indexOf(parseInt(packageId, 10)) > -1);
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';

.ticket {
  color: #fff;
  line-height: 0.45rem;
  text-align: center;
  margin-bottom: 0.4rem;
  font-size: 0.25rem;
}
</style>
